<app-question-card>
  <p question>
    Great! Let's get started.<br /><br />
    What is the home address?
  </p>
  <div class="form-field" input-options>
    <label for="propertyAddress">Address</label>
    <lib-smarty-address-auto-complete
      [(ngModel)]="address"
      name="propertyAddress"
      id="propertyAddress"
      #propertyAddress="ngModel"
      placeholder="Search for address"
      maxlength="100"
      [required]="true"
    ></lib-smarty-address-auto-complete>
  </div>
  <p class="chat-answer" answer>{{address}}</p>
  <button class="w-100" footer (click)="proceedWithAddress()" [disabled]="propertyAddress.invalid">Continue</button>
</app-question-card>
